(function () {
  'use strict';

  const header = document.querySelector('[data-mimobg-header]');
  if (!header) return;

  // ===== Mobile burger → MimoBG drawer =====
  const burger = header.querySelector('[data-mimobg-burger]');
  const drawer = document.querySelector('[data-mimobg-drawer]');
  const drawerCloseEls = drawer ? drawer.querySelectorAll('[data-mimobg-drawer-close]') : [];

  let drawerOpen = false;

  function openDrawer() {
    if (!drawer || drawerOpen) return;
    drawerOpen = true;
    drawer.removeAttribute('hidden');
    document.body.classList.add('mimobg-drawer-open');
    requestAnimationFrame(function () {
      drawer.classList.add('is-visible');
    });
  }

  function closeDrawer() {
    if (!drawer || !drawerOpen) return;
    drawerOpen = false;
    drawer.classList.remove('is-visible');
    document.body.classList.remove('mimobg-drawer-open');
    setTimeout(function () {
      if (!drawerOpen) {
        drawer.setAttribute('hidden', '');
      }
    }, 250);
  }

  if (burger && drawer) {
    burger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    });

    drawerCloseEls.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawerOpen) {
        closeDrawer();
      }
    });

    // Drawer accordion toggles (level 1 & level 2)
    drawer.querySelectorAll('[data-mimobg-drawer-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const item = btn.closest('[data-mimobg-drawer-item]');
        if (!item) return;
        const isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    // Close drawer on link click (само за линкове, не за toggle бутоните)
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        closeDrawer();
      });
    });
  }

  // ===== Search overlay =====
  const searchBtn = header.querySelector('[data-mimobg-search-trigger]');
  const overlay = document.querySelector('[data-mimobg-search-overlay]');
  const input = overlay && overlay.querySelector('[data-mimobg-search-input]');
  const resultsEl = overlay && overlay.querySelector('[data-mimobg-search-results]');
  const closeEls = overlay && overlay.querySelectorAll('[data-mimobg-search-close]');

  if (overlay) {
    overlay.setAttribute('hidden', '');
    overlay.classList.remove('is-visible');
  }

  let isOpen = false;

  function openOverlay() {
    if (!overlay || isOpen) return;
    isOpen = true;
    overlay.removeAttribute('hidden');
    document.body.classList.add('mimobg-search-open');
    requestAnimationFrame(function () {
      overlay.classList.add('is-visible');
    });
    setTimeout(function () { input && input.focus(); }, 50);
  }

  function closeOverlay() {
    if (!overlay || !isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-visible');
    document.body.classList.remove('mimobg-search-open');
    setTimeout(function () {
      if (!isOpen) {
        overlay.setAttribute('hidden', '');
        if (resultsEl) resultsEl.innerHTML = '';
        if (input) input.value = '';
      }
    }, 200);
  }

  if (searchBtn && overlay) {
    searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (isOpen) {
        closeOverlay();
      } else {
        openOverlay();
      }
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeOverlay();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) {
        closeOverlay();
      }
    });

    // ===== Predictive search =====
    let timer = null;
    let lastQ = '';

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function highlightMatch(title, query) {
      const safe = escapeHtml(title);
      if (!query || query.length < 2) return safe;
      const q = escapeHtml(query);
      const regex = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
      return safe.replace(regex, '<mark class="mimobg-search-overlay__highlight">$1</mark>');
    }

    function search(q) {
      const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                  '&resources[type]=product&resources[limit]=6';

      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!resultsEl || !isOpen) return;
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];

          if (!products.length) {
            resultsEl.innerHTML = '<div class="mimobg-search-overlay__empty">Няма резултати за „' + escapeHtml(q) + '"</div>';
            return;
          }

          let html = '<ul class="mimobg-search-overlay__list">';
          products.forEach(function (p) {
            const img = p.image
              ? '<img src="' + p.image + '" alt="" loading="lazy" width="56" height="56">'
              : '';
            const priceStr = p.price ? p.price + ' €' : '';
            const titleHtml = highlightMatch(p.title, q);

            html += '<li><a href="' + p.url + '" class="mimobg-search-overlay__item">' +
                      '<div class="mimobg-search-overlay__thumb">' + img + '</div>' +
                      '<div class="mimobg-search-overlay__info">' +
                        '<span class="mimobg-search-overlay__title">' + titleHtml + '</span>' +
                        (priceStr ? '<span class="mimobg-search-overlay__price">' + escapeHtml(priceStr) + '</span>' : '') +
                      '</div>' +
                    '</a></li>';
          });
          html += '</ul>';
          html += '<a href="/search?q=' + encodeURIComponent(q) + '" class="mimobg-search-overlay__view-all">Виж всички резултати →</a>';
          resultsEl.innerHTML = html;
        })
        .catch(function () {
          if (resultsEl) resultsEl.innerHTML = '<div class="mimobg-search-overlay__empty">Грешка при търсенето.</div>';
        });
    }

    if (input) {
      input.addEventListener('input', function () {
        const q = input.value.trim();
        if (timer) clearTimeout(timer);

        if (q.length < 2) {
          if (resultsEl) resultsEl.innerHTML = '';
          lastQ = '';
          return;
        }

        if (q === lastQ) return;
        lastQ = q;

        timer = setTimeout(function () { search(q); }, 250);
      });
    }
  }

  // ===== Cart trigger =====
  const cartBtn = header.querySelector('[data-mimobg-cart-trigger]');
  if (cartBtn) {
    cartBtn.addEventListener('click', function (e) {
      const cartDrawer = document.querySelector('cart-drawer, [data-cart-drawer]');
      if (cartDrawer && typeof cartDrawer.show === 'function') {
        e.preventDefault();
        cartDrawer.show();
      }
    });
  }

  // ===== Cart count =====
  document.addEventListener('cart:updated', function (e) {
    const count = (e.detail && e.detail.cart && e.detail.cart.item_count) || 0;
    header.querySelectorAll('[data-cart-count]').forEach(function (c) {
      c.textContent = count;
      c.setAttribute('data-cart-count', count);
    });
  });

  // ===== Mega menu accessibility =====
  header.querySelectorAll('[data-mimobg-nav-item]').forEach(function (item) {
    const link = item.querySelector('.mimobg-header__nav-link');
    const mega = item.querySelector('[data-mimobg-mega]');
    if (!mega) return;

    item.addEventListener('focusin', function () {
      link && link.setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) {
        link && link.setAttribute('aria-expanded', 'false');
      }
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        link && link.focus();
        link && link.setAttribute('aria-expanded', 'false');
      }
    });
  });
})();